import React from 'react';
import { t } from '../../utils/helpers';
import { useAvatar } from '../hooks/useAvatar';
import { useRating } from '../hooks/useRating';
import styles from '../styles/user.module.scss';
import { ReactComponent as StarIcon } from '@ui-kit/icons/star.svg';

export const User = (props: { user: string }) => {
  const rating = useRating();
  const [avatar, isLoaded] = useAvatar();

  return (
    <div className={styles.user}>
      <div className="avatar-overlay">
        {isLoaded && <img className={styles.avatar} src={avatar} alt="" />}
      </div>
      <div className={styles.info}>
        <div className={styles.name}>{props.user}</div>
        <div className={styles.rating}>
          <span>{t('rating')} </span>
          <StarIcon />
          <span>{rating}</span>
        </div>
      </div>
    </div>
  );
};
